<div *ngIf="!businesstripApplication.id;else contentWithHeaderInformation">
    <h1>
        {{ ('rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.create' | hisUi) }}
    </h1>
    <his-dialog-header [showSaveButton]="false" [showDraftSaveButton]="true" [showCustomButton]="true"
        [customButtonLabel]="'rm.erp.travelmanagement.businesstripapplication.button.verifyAndSubmit'"
        [customButtonClass]="'button_highlighted_dark_green'" [customButtonImage]="'ARROW_RIGHT_FAT'"
        [showSearchButton]="false" [showBackButton]="false" (customEvent)="dummySaveAndVerify()"
        (saveDraft)="saveBusinesstripApplication()" (resetInputs)="resetBusinesstripApplication()">
    </his-dialog-header>
</div>
<ng-template #contentWithHeaderInformation>
    <h1>
        {{ ( 'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.edit' | hisUi) }}
    </h1>
    <his-dialog-header [showSaveButton]="false" [showDraftSaveButton]="true" [showCustomButton]="true"
        [customButtonLabel]="'rm.erp.travelmanagement.businesstripapplication.button.verifyAndSubmit'"
        [customButtonClass]="'button_highlighted_dark_green'" [customButtonImage]="'ARROW_RIGHT_FAT'"
        [showSearchButton]="true" [showBackButton]="false" (customEvent)="dummySaveAndVerify()"
        (saveDraft)="saveBusinesstripApplication()" (resetInputs)="resetBusinesstripApplication()">
        <ng-container dataBox>
            <strong>{{businesstripApplication.surname}}, {{businesstripApplication.firstname}}</strong>
            |
            <span
                [title]="'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.applicationDate' | hisUi">{{businesstripApplication.applicationDate
                | hisDate }}
            </span>
            |
            <span
                [title]="'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.id' | hisUi">{{businesstripApplication.id}}</span>
        </ng-container>
    </his-dialog-header>
</ng-template>

<div class="clearAndSpace"></div>

<!-- Registerkarten und den field übergeordnete Components hier einordnen-->
<p-tabView>
    <p-tabPanel
        *ngIf="getHisDdKeyHidden('rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData')"
        header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData' | hisUi}}">
        <erp-businesstripapplication-traveldata [(travelData)]="businesstripApplication.travelData"
            (travelDataChange)="onTravelDataChange($event)">
        </erp-businesstripapplication-traveldata>
    </p-tabPanel>

    <p-tabPanel
        header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelItinerary' | hisUi}}"
        [disabled]="tabviewDisabled">
        <erp-businesstripapplication-travel-itinerary
            [listTravelitinerary]="businesstripApplication.listTravelitinerary"
            (travelItineraryChange)="onTravelItineraryChange($event)"></erp-businesstripapplication-travel-itinerary>
    </p-tabPanel>

    <p-tabPanel
        header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad' | hisUi}}"
        [disabled]="businesstripApplication.travelData.countrySelected?.uniquename === '000'">
        <erp-businesstripapplication-travel-abroad [listTravelAbroad]="businesstripApplication.listTravelAbroad"
            (travelAbroadChange)="onTravelAbroadChange($event)"></erp-businesstripapplication-travel-abroad>
    </p-tabPanel>

    <p-tabPanel
        header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.a1bescheinigung' | hisUi}}"
        [disabled]="businesstripApplication.travelData.countrySelected?.uniquename === '000'">
        <erp-businesstripapplication-a1-bescheinigung [a1Bescheinigung]="businesstripApplication.a1Bescheinigung"
            (a1BescheinigungChange)="onA1BescheinigungChange($event)"></erp-businesstripapplication-a1-bescheinigung>
    </p-tabPanel>

    <p-tabPanel header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.assets' | hisUi}}">
        <erp-businesstripapplication-assets [assets]="businesstripApplication.assets"
            (assetsChange)="onAssetsChange($event)">
        </erp-businesstripapplication-assets>
    </p-tabPanel>

    <p-tabPanel
        header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.transportation' | hisUi}}">
        <erp-businesstripapplication-transportation [transportation]="businesstripApplication.transportation"
            (transportationChange)="onTransportationChange($event)">
        </erp-businesstripapplication-transportation>
    </p-tabPanel>

    <p-tabPanel header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bahncard' | hisUi}}"
        [disabled]="tabviewDisabled">
        <erp-businesstripapplication-bahncard [pgdJoinId]="businesstripApplication.pgdJoinId">
        </erp-businesstripapplication-bahncard>
    </p-tabPanel>

    <p-tabPanel
        header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.estimatedCosts' | hisUi}}"
        [disabled]="tabviewDisabled">
        <erp-businesstripapplication-estimated-costs [estimatedCosts]="businesstripApplication.estimatedCosts"
            (estimatedCostsChange)="onEstimatedCostsChange($event)">
        </erp-businesstripapplication-estimated-costs>
    </p-tabPanel>

    <!--<p-tabPanel
        header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.financing' | hisUi}}">
        <erp-businesstripapplication-financing [listFinancing]="businesstripApplication.listFinancing"
            (financingChange)="onFinancingChange($event)">
        </erp-businesstripapplication-financing>
    </p-tabPanel>-->

    <p-tabPanel
        header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.reimbursementCosts' | hisUi}}">
        <erp-businesstripapplication-reimbursement-costs
            [reimbursementCosts]="businesstripApplication.reimbursementCosts"
            (reimbursementCostsChange)="onReimbursementCostsChange($event)">
        </erp-businesstripapplication-reimbursement-costs>
    </p-tabPanel>

    <p-tabPanel
        header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.bankDetails' | hisUi}}">
        <erp-businesstripapplication-bankdetails [bankDetails]="businesstripApplication.bankDetails"
            (bankDetailsChange)="onBankDetailsChange($event)">
        </erp-businesstripapplication-bankdetails>
    </p-tabPanel>

    <p-tabPanel header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.documents' | hisUi}}"
        [disabled]="tabviewDisabled">
        <erp-businesstripapplication-documents [documents]="businesstripApplication.documents"
            (documentsChange)="onDocumentsChange($event)"></erp-businesstripapplication-documents>
    </p-tabPanel>

    <p-tabPanel
        header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.furtherDetails' | hisUi}}"
        [disabled]="tabviewDisabled">
        <erp-businesstripapplication-further-details
            [furtherDetails]="businesstripApplication.furtherDetails"></erp-businesstripapplication-further-details>
    </p-tabPanel>

</p-tabView>